import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { DxButtonModule, DxContextMenuComponent, DxContextMenuModule, DxDrawerModule, DxListModule, DxScrollViewModule, DxToolbarModule, DxTreeViewModule } from "devextreme-angular";
import { SideNavInnerToolbarComponent } from "./side-nav-inner-toolbar/side-nav-inner-toolbar.component";
import { SideNavOuterToolbarComponent } from "./side-nav-outer-toolbar/side-nav-outer-toolbar.component";
import { SingleCardComponent } from "./single-card/single-card.component";
import { UserPanelComponent } from "./user-panel/user-panel.component";
import { HeaderComponent } from "./header/header.component";
import { FooterComponent } from "./footer/footer.component";
import { SideNavigationMenuComponent } from "./side-navigation-menu/side-navigation-menu.component";

@NgModule({
  declarations: [
    SideNavOuterToolbarComponent,
    SideNavInnerToolbarComponent,
    SingleCardComponent,
    UserPanelComponent,
    HeaderComponent,
    FooterComponent,
    SideNavigationMenuComponent
  ],
  exports: [
    SideNavOuterToolbarComponent,
    SideNavInnerToolbarComponent,
    SingleCardComponent
  ],
  imports: [
    DxDrawerModule,
    DxScrollViewModule,
    DxToolbarModule,
    CommonModule,
    DxTreeViewModule,
    DxContextMenuModule,
    DxListModule,
    DxButtonModule
  ],
})
export class LayoutsModule { }
